import { ArrowRightIcon } from 'assets/icons';
import { CustomButton, CustomTextArea } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { FC, useEffect, useState } from 'react';
import { VoidFn } from 'types/baseTypes';

interface PayoutNotesPanelProps {
  onClose: VoidFn;
  onSave: (data: string) => void;
  payoutNotes: string;
}

const PayoutNotesPanel: FC<PayoutNotesPanelProps> = ({ onClose, onSave, payoutNotes }) => {
  const [notes, setNotes] = useState('');

  useEffect(() => {
    setNotes(payoutNotes);
  }, [payoutNotes]);

  const handleSaveNotes = () => {
    onSave(notes.trim());
  };

  const isSaveButtonDisabled = () => {
    return payoutNotes === notes.trim() || !notes.trim() || !notes;
  };

  return (
    <div className="h-full w-96">
      <div
        className="flex cursor-pointer items-center gap-3 border-b border-[#D9D9D9] px-3.5 pb-4 pt-6"
        onClick={onClose}>
        <ArrowRightIcon className="rotate-180" />
        <div className="text-17px text-headingGray font-semibold">Notes</div>
      </div>
      <div className="px-[30px] pb-10">
        <div className="relative mt-7 mb-5">
          <CustomTextArea
            id="payout-notes-input"
            name="payout-notes"
            value={notes}
            onChange={setNotes}
            placeholder="Enter notes"
            maxLength={250}
            className="border-borderGray text-primaryText focus:border-secondary h-32 
            max-h-[128px] w-full rounded-[7px] border bg-transparent p-3 focus:outline-none"
            showRemainingChar
            remainingCharClassName="pt-2.5"
          />
          {notes && (
            <label
              htmlFor="payout-notes-input"
              className="bg-primary absolute -top-3 left-3 px-2 text-sm text-gray-600 transition-all">
              Enter notes
            </label>
          )}
        </div>

        <div className="space-y-5">
          <CustomButton
            className="w-full "
            id="notes-save-button"
            type={ButtonType.PRIMARY}
            disabled={isSaveButtonDisabled()}
            onClick={handleSaveNotes}>
            Save
          </CustomButton>
          <CustomButton className="w-full " id="notes-cancel-button" type={ButtonType.SECONDARY} onClick={onClose}>
            Cancel
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default PayoutNotesPanel;
